import { Box, Button, ColorOptions, Form, Icon, Image, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, ReactElement, useEffect } from 'react'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { Colors, isOsMobile, isSessionValid, storeData, useWindowDimensions } from '../../../util/util'
import { formData } from './FormData'
import { styles } from './styles'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'

const QrAgentLogin: FC = () => {
  const { getAppAuthGenOtpOrLogin, updateMobile, resetAccessToken, setInitialized } = useStores((store) => ({
    getAppAuthGenOtpOrLogin: store?.agentQrUser?.getAppAuthGenOtpOrLogin,
    updateMobile: store?.agentQrUser?.updateMobileNumber,
    resetAccessToken: store.agentQrSession.resetAccessToken,
    setInitialized: store.agentQrSession.setInitialized,
  }))

  useEffect(() => {
    setInitialized(true)
    if (navigation?.canGoBack()) {
      navigation.goBack()
    } else {
      const csoSessData = window.localStorage.getItem('csoSessData')
      if (csoSessData && csoSessData?.length > 0 && isSessionValid(csoSessData)) {
        navigation.reset({
          index: 0,
          routes: [{ name: Routes.midslist }],
        })
      } else {
        resetAccessToken()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const viewPort = useWindowDimensions()
  const navigation = useNavigation()
  const [callAppAuth, appAuthHandler] = useLazyApiData(getAppAuthGenOtpOrLogin)

  useEffect(() => {
    if (appAuthHandler.state === 'fulfilled') {
      navigation?.navigate(Routes.QrAgentOtp)
    }
  }, [appAuthHandler.state, navigation])

  const renderActionButtons = ({ handleSubmit, values, isValid }: any): ReactElement => {
    const handleResetPress = (): void => {
      handleSubmit()
      updateMobile(values?.mobileNumber)
      storeData('csoUserMobileNumber', values?.mobileNumber)
      if (values?.mobileNumber?.length === 10 && isValid) {
        callAppAuth(values?.mobileNumber)
      }
    }
    return (
      <Box {...styles.buttonContainer}>
        <Button
          isFull
          isLoading={appAuthHandler.state === 'pending'}
          disabled={!isValid}
          type={'primary'}
          color={'#0070B6' as ColorOptions}
          testID="send-otp"
          onPress={handleResetPress}>
          <Text color={'WHITE'} fontFamily={'jiotype-medium'} fontSize={14}>
            {'Send OTP'}
          </Text>
        </Button>
      </Box>
    )
  }

  const handleBack = (): void | undefined => {
    navigation?.goBack()
  }
  return (
    <Box
      w={'100%'}
      h={'100vh'}
      alignItems={'center'}
      justifyContent={'flex-start'}
      backgroundColor={Colors.SPLASH as ColorOptions}
      safeArea>
      <Box h={32} w={'100%'} alignItems={'center'} justify={'center'} margin={36}>
        <Image source={require('../../../assets/images/jiopaybuzz_white.png')} height={32} width={143} />
      </Box>
      <Box
        p={16}
        minWidth={viewPort > 432 ? 320 : viewPort - 36}
        minHeight={viewPort > 432 ? 280 : undefined}
        justifyContent="center"
        backgroundColor={'WHITE'}
        borderRadius={8}>
        <ModBox show={isOsMobile()} testID="arrow-back" onPress={handleBack} {...styles.imgStyle}>
          <Icon id={'ARROW_BACK'} color={'PRIMARY'} size={24} />
        </ModBox>
        <Box margin={24} underlayColor="WHITE">
          <Text {...styles.titleStyle}>{'CSO Member Login'}</Text>
          <Spacer size={24} direction={'vertical'} />
          <Box {...styles.formContainer}>
            <Form
              initialValues={{
                mobileNumber: '',
              }}
              container={DefaultFormContainer}
              formData={formData()}
              actionButtons={renderActionButtons}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { QrAgentLogin as default }
